import { instanceToPlain } from "class-transformer";
import ProjectConfigRequestResource from "common/resources/Project/Config/ProjectConfig/ProjectConfigRequestResource";
import ProjectConfigResponseResource from "common/resources/Project/Config/ProjectConfig/ProjectConfigResponseResource";
import BaseConfigApi from "./BaseConfigApi";

export default class ConfigApi extends BaseConfigApi {
	/**
	 * @description Get by project id
	 */
	public async getByProjectId(projectId: string): Promise<ProjectConfigResponseResource> {
		return this.getRequest<ProjectConfigResponseResource>(this.getBaseUrl({ projectId })).then((response) => ProjectConfigResponseResource.hydrate(response));
	}

	/**
	 * @description Get by project config id
	 */
	public async getByProjectConfigId(projectId: string, projectConfigId: string): Promise<ProjectConfigResponseResource> {
		return this.getRequest<ProjectConfigResponseResource>(`${this.getBaseUrl({ projectId })}/${projectConfigId}`).then((response) =>
			ProjectConfigResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Create a new project config, or get the existing one
	 */
	public async create(projectId: string, request: ProjectConfigRequestResource): Promise<ProjectConfigResponseResource> {
		return this.postRequest<ProjectConfigResponseResource>(this.getBaseUrl({ projectId }), instanceToPlain(request)).then((response) =>
			ProjectConfigResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Update a project config
	 */
	public async update(projectId: string, projectConfigId: string, request: ProjectConfigRequestResource): Promise<ProjectConfigResponseResource> {
		return this.putRequest<ProjectConfigResponseResource>(`${this.getBaseUrl({ projectId })}/${projectConfigId}`, instanceToPlain(request)).then((response) =>
			ProjectConfigResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Delete a project config
	 */
	public async delete(projectId: string, projectConfigId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId })}/${projectConfigId}`);
	}

	/**
	 * @description Publish a project
	 */
	public async publish(projectId: string): Promise<void> {
		return this.postRequest(`${this.getBaseUrl({ projectId })}/publish`);
	}
}
